import { useState, useEffect } from 'react';
import { getCovoiturage, monterVoiture, affecterVoiture } from '../api';

/**
 * Voitures d'un match à l'extérieur : qui conduit, qui monte avec qui.
 *   mode « joueur » : je choisis ma voiture, ou je vois mes passagers
 *   mode « coach »  : je place et déplace tout le monde
 * `cle` change quand la réponse du joueur change, pour recharger.
 */
export default function Voitures({ rencontreId, mode = 'joueur', onToast, cle }) {
  const [e, setE] = useState(null);
  const [envoi, setEnvoi] = useState(false);
  const charger = () => getCovoiturage(rencontreId).then(setE).catch(() => {});
  useEffect(() => { charger(); }, [rencontreId, cle]);
  if (!e) return null;

  async function agir(fn, ok) {
    setEnvoi(true);
    try { const r = await fn(); setE({ ...r.covoiturage, moi: e.moi }); charger(); if (ok) onToast?.(ok); }
    catch (err) { onToast?.(err.message, 'error'); }
    finally { setEnvoi(false); }
  }
  const nom = p => `${p.prenom} ${(p.nom || '').charAt(0)}.`;
  const coach = mode === 'coach';
  const moi = e.moi || {};
  const maVoiture = moi.role === 'passager' ? moi.conducteur_id : null;

  if (!coach && !['conducteur', 'passager'].includes(moi.role)) return null;
  if (!e.conducteurs.length && !e.a_placer.length) return null;

  return (
    <div style={{ marginTop:12 }}>
      <div style={{ fontSize:10, color:'var(--muted)', letterSpacing:1.5, textTransform:'uppercase', fontWeight:600, marginBottom:8 }}>
        🚙 Les voitures</div>

      {e.manque > 0 && (
        <div style={{ fontSize:12, color:'#fca5a5', background:'rgba(var(--danger-rgb),.08)', border:'1px solid rgba(var(--danger-rgb),.3)',
                      borderRadius:8, padding:'7px 10px', marginBottom:8 }}>
          Il manque {e.manque} place{e.manque > 1 ? 's' : ''} pour emmener tout le monde.</div>)}

      {e.conducteurs.length === 0 && (
        <div style={{ fontSize:12, color:'var(--muted)', marginBottom:8 }}>Personne ne propose encore de place.</div>)}

      {e.conducteurs.map(c => {
        const jySuis = maVoiture === c.joueur_id;
        return (
          <div key={c.joueur_id} style={{ border:`1px solid ${jySuis ? 'var(--accent)' : 'var(--border)'}`, borderRadius:10,
                                         padding:'9px 11px', marginBottom:7, background: jySuis ? 'rgba(var(--accent-rgb),.07)' : 'transparent' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:8 }}>
              <div style={{ fontSize:13, fontWeight:700 }}>🚗 {nom(c)}
                <span style={{ fontWeight:400, color:'var(--muted)', fontSize:11.5 }}>
                  {' '}· {c.libres > 0 ? `${c.libres} place${c.libres > 1 ? 's' : ''} libre${c.libres > 1 ? 's' : ''}` : 'complète'}</span></div>
              {!coach && moi.role === 'passager' && (jySuis
                ? <button disabled={envoi} onClick={() => agir(() => monterVoiture(rencontreId, null), 'Tu es descendu de la voiture')}
                          style={btn('var(--muted)')}>Descendre</button>
                : c.libres > 0 && <button disabled={envoi} onClick={() => agir(() => monterVoiture(rencontreId, c.joueur_id), `Tu montes avec ${c.prenom}`)}
                          style={btn('var(--accent)', true)}>{maVoiture ? 'Changer' : 'Monter'}</button>)}
            </div>
            <div style={{ fontSize:12, color:'var(--muted)', marginTop:5, display:'flex', flexWrap:'wrap', gap:6 }}>
              {c.passagers.length === 0 && <span>Aucun passager pour l'instant</span>}
              {c.passagers.map(p => coach
                ? <Deplacer key={p.joueur_id} p={p} nom={nom} conducteurs={e.conducteurs} actuel={c.joueur_id} disabled={envoi}
                            onChange={cid => agir(() => affecterVoiture(rencontreId, p.joueur_id, cid))} />
                : <span key={p.joueur_id} style={{ color:'var(--text)', background:'var(--bg)', borderRadius:6, padding:'2px 8px' }}>{nom(p)}</span>)}
            </div>
          </div>);
      })}

      {e.a_placer.length > 0 && (
        <div style={{ fontSize:12, color:'#eab308', marginTop:4 }}>
          <div style={{ marginBottom:5 }}>À placer :</div>
          <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
            {e.a_placer.map(p => coach
              ? <Deplacer key={p.joueur_id} p={p} nom={nom} conducteurs={e.conducteurs} actuel={null} disabled={envoi}
                          onChange={cid => agir(() => affecterVoiture(rencontreId, p.joueur_id, cid))} />
              : <span key={p.joueur_id} style={{ background:'rgba(234,179,8,.1)', borderRadius:6, padding:'2px 8px' }}>{nom(p)}</span>)}
          </div>
        </div>)}
    </div>
  );
}

/** Pour le coach : un passager et la voiture où le placer. */
function Deplacer({ p, nom, conducteurs, actuel, onChange, disabled }) {
  return (
    <select value={actuel || ''} disabled={disabled} onChange={ev => onChange(ev.target.value ? Number(ev.target.value) : null)}
            aria-label={`Voiture de ${nom(p)}`}
            style={{ background:'var(--bg)', color:'var(--text)', border:'1px solid var(--border)', borderRadius:6,
                     fontSize:12, padding:'3px 6px', maxWidth:200 }}>
      <option value="">{nom(p)} — à placer</option>
      {conducteurs.filter(c => c.libres > 0 || c.joueur_id === actuel).map(c => (
        <option key={c.joueur_id} value={c.joueur_id}>{nom(p)} → avec {nom(c)}</option>))}
    </select>
  );
}

const btn = (couleur, plein) => ({
  background: plein ? couleur : 'none', color: plein ? 'var(--accent-text)' : couleur,
  border: plein ? 'none' : '1px solid var(--border)', borderRadius:7,
  fontSize:11.5, fontWeight:700, padding:'5px 11px', cursor:'pointer', whiteSpace:'nowrap'
});
